import { loadRuntimeConfig } from './runtime-config';
import {
  browserRecoveryEnvironment,
  isChunkLoadError,
  recoverFromChunkError,
  showChunkFailure,
} from './chunk-recovery';

loadRuntimeConfig().then(() => import('./bootstrap')).catch((error: unknown) => {
  // D33：入口分包在发版后已不存在时自动重新加载一次，二次失败给出明确提示。
  if (isChunkLoadError(error)) {
    if (!recoverFromChunkError(undefined, browserRecoveryEnvironment())) showChunkFailure();
    return;
  }
  const app = document.querySelector('#app');
  if (!app) return;
  const message = document.createElement('p');
  message.textContent = '应用暂时无法加载，请稍后刷新；若持续失败，请联系管理员检查服务配置。';
  const retry = document.createElement('button');
  retry.textContent = '重新加载';
  retry.addEventListener('click', () => location.reload());
  app.replaceChildren(message, retry);
});
